<template>
    <div v-if="doctor !== null">
        <b-modal
            size="lg"
            v-model="modalShow"
            title="医師追加"
            @hidden="close">
            <form @submit.stop.prevent="addDoctor">
                <section>
                    <h5 class="sectionHeader">基本設定</h5>
                    <div class="row">
                        <div class="col-12 col-sm-6">
                            <div class="form-group m-form__group">
                                <label for="last_name" class="is-required-ja">姓</label>
                                <input
                                    v-model="doctor.last_name"
                                    id="last_name"
                                    class="form-control m-input"
                                    :class="{ 'is-invalid' : errors.last_name }"
                                    type="text"
                                    placeholder="姓">
                                <div
                                    class="invalid-feedback d-block mt-1"
                                    v-if="errors.last_name">
                                    {{ errors.last_name[0] }}
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-sm-6">
                            <div class="form-group m-form__group">
                                <label for="first_name" class="is-required-ja">名</label>
                                <input
                                    v-model="doctor.first_name"
                                    id="first_name"
                                    class="form-control m-input"
                                    :class="{ 'is-invalid' : errors.first_name }"
                                    type="text"
                                    placeholder="名">
                                <div
                                    class="invalid-feedback d-block mt-1"
                                    v-if="errors.first_name">
                                    {{ errors.first_name[0] }}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12 col-sm-6">
                            <div class="form-group m-form__group">
                                <label for="last_name_kana" class="is-required-ja">セイ</label>
                                <input
                                    v-model="doctor.last_name_kana"
                                    id="last_name_kana"
                                    class="form-control m-input"
                                    :class="{ 'is-invalid' : errors.last_name_kana }"
                                    type="text"
                                    placeholder="セイ">
                                <div
                                    class="invalid-feedback d-block mt-1"
                                    v-if="errors.last_name_kana">
                                    {{ errors.last_name_kana[0] }}
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-sm-6">
                            <div class="form-group m-form__group">
                                <label for="first_name_kana" class="is-required-ja">メイ</label>
                                <input
                                    v-model="doctor.first_name_kana"
                                    id="first_name_kana"
                                    class="form-control m-input"
                                    :class="{ 'is-invalid' : errors.first_name_kana }"
                                    type="text"
                                    placeholder="メイ">
                                <div
                                    class="invalid-feedback d-block mt-1"
                                    v-if="errors.first_name_kana">
                                    {{ errors.first_name_kana[0] }}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12 col-sm-6">
                            <div class="mb-3">
                                <label for="postcode">郵便番号</label>
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">〒</span>
                                    </div>
                                    <input
                                        v-model="doctor.postcode"
                                        @change="changePostcode"
                                        type="text"
                                        id="postcode"
                                        class="form-control"
                                        :class="{ 'is-invalid' : errors.postcode }"
                                        placeholder="000-1111">
                                    <div v-if="errors.postcode"
                                         class="invalid-feedback d-block">
                                        {{ errors.postcode[0] }}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-sm-6">
                            <div class="mb-3">
                                <label for="prefecture">都道府県</label>
                                <select
                                    v-model="doctor.prefecture"
                                    id="prefecture"
                                    class="form-control"
                                    :class="{ 'is-invalid' : errors.prefecture }">
                                    <option value="">選択してください</option>
                                    <option v-for="pref in prefmap" :value="pref">
                                        {{ pref }}
                                    </option>
                                </select>
                                <div
                                    v-if="errors.prefecture"
                                    class="invalid-feedback d-block">
                                    {{ errors.prefecture[0] }}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12 col-sm-6">
                            <div class="mb-3">
                                <label for="address">市区町村・番地</label>
                                <input
                                    v-model="doctor.address"
                                    type="text"
                                    id="address"
                                    class="form-control"
                                    :class="{ 'is-invalid' : errors.address }"
                                    placeholder="市区町村・番地">
                                <div
                                    v-if="errors.address"
                                    class="invalid-feedback d-block">
                                    {{ errors.address[0] }}
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-sm-6">
                            <div class="mb-3">
                                <label for="building">建物名など</label>
                                <input
                                    v-model="doctor.building"
                                    type="text"
                                    id="building"
                                    class="form-control"
                                    :class="{ 'is-invalid' : errors.building }"
                                    placeholder="建物名など">
                                <div
                                    v-if="errors.building"
                                    class="invalid-feedback d-block">
                                    {{ errors.building[0] }}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12 col-sm-6">
                            <div class="form-group m-form__group">
                                <div>
                                    <label for="tel">電話番号<span class="small">（滞在している国の国際番号）</span></label>
                                    <vue-tel-input
                                        v-model="doctor.tel"
                                        id="tel"
                                        name="tel"
                                        :class="{ 'is-invalid' : errors.tel || telObj.valid === false }"
                                        placeholder="000-1111-2222"
                                        valid-characters-only
                                        default-country="JP"
                                        @validate="onValidateTel">
                                    </vue-tel-input>
                                    <div v-if="errors.tel" class="invalid-feedback d-block">{{ errors.tel[0] }}</div>
                                    <div v-if="telObj.valid === false" class="invalid-feedback d-block">電話番号を正しく入力してください</div>
                                </div>

                                <template v-if="$locale.type === 'consul'">
                                    <div class="form-group mt-1 mb-0">
                                        <div class="form-check form-check-inline">
                                            <input
                                                v-model="doctor.doctor_metadata.is_sms_consultation_authorized"
                                                type="checkbox"
                                                id="is_sms_consultation_authorized"
                                                class="form-check-input">
                                            <label
                                                for="is_sms_consultation_authorized"
                                                class="mb-0">
                                                予約確定時に電話番号宛にSMSを送信する
                                            </label>
                                        </div>
                                    </div>
                                    <div class="form-group mt-0">
                                        <div class="form-check form-check-inline">
                                            <input
                                                v-model="isSendSms"
                                                :disabled="!doctor.doctor_metadata.is_sms_consultation_authorized"
                                                type="checkbox"
                                                id="isSendSms"
                                                class="form-check-input">
                                            <label
                                                for="isSendSms"
                                                class="mb-0"
                                                :class="{ 'text-muted' : !doctor.doctor_metadata.is_sms_consultation_authorized }">
                                                医師に確認用のSMSを送信する
                                            </label>
                                        </div>
                                    </div>
                                </template>
                            </div>
                        </div>
                        <div class="col-12 col-sm-6">
                            <div class="mb-3">
                                <label for="priority_num" class="is-required-ja">表示優先度</label>
                                <input
                                    v-model="doctor.priority_num"
                                    type="text"
                                    id="priority_num"
                                    class="form-control"
                                    :class="{ 'is-invalid' : errors.priority_num }"
                                    placeholder="数値が大きいほどメニュー一覧で上に表示されます">
                                <div
                                    v-if="errors.priority_num"
                                    class="invalid-feedback d-block">
                                    {{ errors.priority_num[0] }}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12 col-sm-6">
                            <div class="form-group m-form__group">
                                <label for="email" class="is-required-ja">メールアドレス</label>
                                <input
                                    v-model="doctor.email"
                                    id="email"
                                    class="form-control m-input"
                                    :class="{ 'is-invalid' : errors.email }"
                                    type="text"
                                    placeholder="メールアドレス">
                                <div
                                    class="invalid-feedback d-block mt-1"
                                    v-if="errors.email">
                                    {{ errors.email[0] }}
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-sm-6">
                            <div class="form-group m-form__group">
                                <label for="password" class="is-required-ja">パスワード</label>
                                <div class="input-group">
                                    <input
                                        v-model="doctor.password"
                                        id="password"
                                        class="form-control m-input"
                                        :class="{ 'is-invalid' : errors.password }"
                                        :type="isShowPassword ? 'text' : 'password'"
                                        placeholder="パスワード">
                                    <div
                                        v-b-tooltip.hover
                                        :title="isShowPassword ? 'パスワードを非表示' : 'パスワードを表示'"
                                        class="input-group-append vc-input-password-append"
                                        @click="isShowPassword = !isShowPassword">
                                        <span
                                            v-if="isShowPassword"
                                            class="input-group-text">
                                            <b-icon-eye-slash-fill />
                                        </span>
                                        <span
                                            v-else
                                            class="input-group-text">
                                            <b-icon-eye-fill />
                                        </span>
                                    </div>
                                    <b-tooltip
                                        target="password"
                                        triggers="hover">
                                        <div>パスワードはアルファベット（小・大文字を両方含む）と数字の組み合わせ8～32文字で設定してください。</div>
                                        <div class="mt-3">
                                            <div>記号は以下を使用できます。</div>
                                            <div class="font-weight-bold">&nbsp;!&nbsp;$&nbsp;%&nbsp;+&nbsp;/&nbsp;=&nbsp;?&nbsp;[&nbsp;]&nbsp;@&nbsp;</div>
                                        </div>
                                    </b-tooltip>
                                    <div
                                        v-if="errors.password"
                                        class="invalid-feedback d-block mt-1">
                                        {{ errors.password[0] }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12 col-lg-6">
                            <div class="form-group mt-0 mb-0">
                                <div class="form-check form-check-inline">
                                    <input
                                        v-model="doctor.is_test"
                                        type="checkbox"
                                        id="is_test"
                                        class="form-check-input"
                                        value="1">
                                    <label
                                        for="is_test"
                                        class="mb-0">
                                        テスト用の医師にする
                                    </label>
                                </div>
                            </div>
                            <div
                                v-if="errors.is_test"
                                class="invalid-feedback d-block">
                                {{ errors.is_test[0] }}
                            </div>
                        </div>
                        <div class="col-12 col-lg-6">
                            <div class="form-group mt-0 mb-0">
                                <div class="form-check form-check-inline">
                                    <input
                                        v-model="doctor.flg_reset_password"
                                        type="checkbox"
                                        id="flg_reset_password"
                                        class="form-check-input"
                                        value="1">
                                    <label
                                        for="flg_reset_password"
                                        class="mb-0">
                                        パスワードの初期設定を完了済みにする
                                    </label>
                                </div>
                            </div>
                            <div
                                v-if="errors.flg_reset_password"
                                class="invalid-feedback d-block">
                                {{ errors.flg_reset_password[0] }}
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col">
                            <div class="mt-3">
                                <label>管理用タグ</label>
                                <vue-tags-input
                                    v-model="doctorManagementTag"
                                    :tags="doctorManagementTags"
                                    @tags-changed="tags => syncDoctorManagementTag(tags)"
                                    placeholder="管理用タグを追加"
                                />
                                <div v-if="errors.doctor_management_tags"
                                     class="invalid-feedback d-block">
                                    {{ errors.doctor_management_tags[0] }}
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section class="mt-5">
                    <h5 class="sectionHeader">詳細設定</h5>
                    <div class="row">
                        <div class="col-12">
                            <div class="mb-3">
                                <label>ラベル</label>
                                <vue-tags-input
                                    v-model="doctorLabel"
                                    :tags="doctorLabels"
                                    @tags-changed="labels => syncDoctorLabel(labels)"
                                    placeholder="ラベルを追加"
                                />
                                <div v-if="errors.doctor_labels"
                                     class="invalid-feedback d-block">
                                    {{ errors.doctor_labels[0] }}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12">
                            <div class="mb-3">
                                <label>略歴</label>
                                <div v-for="(history, idx) in doctorHistories">
                                    <div class="row">
                                        <div class="col-12 col-lg-3 mb-2">
                                            <select
                                                v-model="history.accrual_year"
                                                class="form-control"
                                                :class="{ 'is-invalid' : errors[`accrual_year.${idx}`] }">
                                                <option :value="null">選択してください</option>
                                                <option
                                                    v-for="n in rangeYear"
                                                    :value="n + yearBase">
                                                    {{ n + yearBase }}年
                                                </option>
                                            </select>
                                        </div>
                                        <div class="col-12 col-lg-8 mb-2">
                                            <input
                                                v-model="history.content"
                                                type="text"
                                                class="form-control"
                                                :class="{ 'is-invalid' : errors[`content.${idx}`] }"
                                                placeholder="例: ○○県○○市の△△クリニックにて勤務。">
                                        </div>
                                        <div class="col-12 col-lg-1 mb-2">
                                            <button
                                                type="button"
                                                class="btn"
                                                style="width:100%; background-color: #F2F3F4;"
                                                @click="removeDoctorHistory(idx)">
                                                -
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div class="d-flex justify-content-center">
                                    <button
                                        type="button"
                                        class="btn btn-yokumiru-blue btn-sm"
                                        style="width:120px;"
                                        @click="pushDoctorHistory">
                                        行を追加
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12">
                            <div class="mb-3">
                                <label>資格・所属学会等</label>
                                <div v-for="(license, idx) in doctorLicenses">
                                    <div class="row">
                                        <div class="col mb-2">
                                            <input
                                                v-model="license.content"
                                                type="text"
                                                class="form-control"
                                                :class="{ 'is-invalid' : errors[`content.${idx}`] }"
                                                placeholder="例: 医学博士">
                                        </div>
                                        <div class="col-12 col-lg-1 mb-2">
                                            <button
                                                type="button"
                                                class="btn"
                                                style="width:100%; background-color: #F2F3F4;"
                                                @click="removeDoctorLicense(idx)">
                                                -
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div class="d-flex justify-content-center">
                                    <button
                                        type="button"
                                        class="btn btn-yokumiru-blue btn-sm"
                                        style="width:120px;"
                                        @click="pushDoctorLicense">
                                        行を追加
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-6">
                            <label>プロフィール画像</label>
                            <div id="c-upload" class="c-upload">
                                <div
                                    v-if="image.base64 !== null"
                                    class="c-upload__image">
                                    <div class="c-upload__delete d-none"
                                         :class="{ 'd-flex justify-content-center align-items-center' : image.base64 }">
                                        <label
                                            class="btn btn-sm btn-danger"
                                            @click="prepareDeleteImage">
                                            画像を削除
                                        </label>
                                    </div>
                                    <img :src="image.base64">
                                </div>
                                <div
                                    v-else-if="doctor.image_url"
                                    class="c-upload__image">
                                    <div
                                        class="c-upload__delete d-none"
                                        :class="{ 'd-flex justify-content-center align-items-center' : doctor.presigned_url }">
                                        <label
                                            class="btn btn-sm btn-danger"
                                            @click="prepareDeleteImage">
                                            画像を削除
                                        </label>
                                    </div>
                                    <img :src="doctor.presigned_url">
                                </div>
                                <div
                                    v-else
                                    class="c-upload__image c-upload__image--default">
                                    <img src="/images/common/profile_default.svg">
                                </div>

                                <div class="input-group input-profile-image-wrapper mt-3">
                                    <b-form-file
                                        v-model="image.object"
                                        ref="fileinput"
                                        placeholder="画像（jpg, png, gif）をアップロード"
                                        accept="image/jpeg, image/png, image/gif"
                                        :class="{ 'is-invalid' : errors.profile_image }"
                                        @change="bindSelectedImage">
                                    </b-form-file>
                                </div>
                            </div>
                            <div
                                v-if="errors.profile_image"
                                class="invalid-feedback d-block">
                                {{ errors.profile_image[0] }}
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12">
                            <label
                                for="introduction"
                                class="mt-3">
                                メッセージ
                            </label>
                            <b-form-textarea
                                v-model="doctor.introduction"
                                :rows="5"
                                id="introduction">
                            </b-form-textarea>
                        </div>
                    </div>
                </section>

                <section class="mt-5">
                    <h5 class="sectionHeader">{{ $locale.consultation_host }}設定</h5>
                    <div class="row">
                        <div class="col-12">
                            <div class="m-form__group form-group">
                                <label class="is-required-ja">{{ $locale.consultation_host }}科</label>
                                <div
                                    class="row m-0 medicalCourseCheckboxes"
                                    :class="{ 'is-invalid' : !!errors.medical_courses !== false }">
                                    <div v-for="medicalCourse in medicalCourses"
                                         class="col col-sm-6 col-md-4 mb-1">
                                        <div class="form-check">
                                            <label>
                                                <input
                                                    v-model="selectedMedicalCourseIds"
                                                    class="form-check-input"
                                                    type="checkbox"
                                                    name="medical_courses"
                                                    :value="medicalCourse.id"
                                                    :class="{ 'is-invalid' : errors.medical_courses }">
                                                {{ medicalCourse.name }}
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div
                                v-if="errors.medical_courses"
                                class="invalid-feedback d-block mb-3">
                                {{ errors.medical_courses[0] }}
                            </div>
                        </div>
                    </div>

                    <div
                        v-if="$store.state.configs.timezone == 1"
                        class="row">
                        <div class="col-12 col-lg-6">
                            <div class="mb-3">
                                <label for="timezone">タイムゾーン</label>
                                <select
                                    v-model="doctor.timezone"
                                    id="timezone"
                                    class="form-control"
                                    :class="{ 'is-invalid' : errors.timezone }">
                                    <option value="">選択してください</option>
                                    <option v-for="timezone in timezones" :value="timezone.key">
                                        {{ timezone.value }}
                                    </option>
                                </select>
                                <div
                                    v-if="errors.timezone"
                                    class="invalid-feedback d-block">
                                    {{ errors.timezone[0] }}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12 col-lg-6">
                            <div class="mb-3">
                                <label for="reservation_allow_before_min">予約可能時間</label>
                                <div class="d-flex align-items-center">
                                    <span class="textPrefix text-muted mr-2">予定開始時間の</span>
                                    <select
                                        v-model="doctor.reservation_allow_before_min"
                                        id="reservation_allow_before_min"
                                        name="reservation_allow_before_min"
                                        class="selectReservationAllowBeforeMin form-control custom-select"
                                        :class="{ 'is-invalid' : errors.reservation_allow_before_min }">
                                        <option value="0">0時間</option>
                                        <option value="720">12時間</option>
                                        <option value="1440">24時間（1日）</option>
                                        <option value="2880">48時間（2日）</option>
                                        <option value="4320">72時間（3日）</option>
                                    </select>
                                    <span class="textSuffix text-muted ml-2">前まで</span>
                                </div>
                                <div
                                    v-if="errors.reservation_allow_before_min"
                                    class="invalid-feedback d-block">
                                    {{ errors.reservation_allow_before_min[0] }}
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </form>

            <div slot="modal-footer">
                <div class="d-flex align-items-center justify-content-end">
                    <div class="form-check float-right mr-4">
                        <input
                            v-model="send_mail"
                            class="form-check-input"
                            type="checkbox"
                            id="send_mail">
                        <label
                            for="send_mail"
                            class="form-check-label">
                            医師に確認メールを送信する
                        </label>
                    </div>
                    <button
                        class="btn btn-yokumiru-gray mr-2"
                        @click="close">
                        キャンセル
                    </button>
                    <button
                        class="btn btn-yokumiru-orange"
                        :disabled="inProgress || !telObj.valid"
                        @click="handleOk">
                        追加
                    </button>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
    import constants from '../../../constants'
    import moment from 'moment-timezone'
    import VueTagsInput from '@johmun/vue-tags-input'

    export default {
        name: 'AddDoctorModal',

        components: {
            VueTagsInput,
        },

        props: {
            env: {
                type: String,
                required: true,
            },
        },

        data: function() {
            return {
                send_mail: false,
                inProgress :false,
                modalShow: false,
                medical_courses: null,
                doctorManagementTag: '',
                doctorManagementTags: [],
                doctorLabel: '',
                doctorLabels: [],
                doctorHistories: [],
                doctorLicenses: [],
                doctor: null,
                image: {
                    name: null,
                    object: null,
                    base64: null,
                },
                yearBase: 1899,
                yearTo: moment().year(),
                errors: {},
                medicalCourses: [],
                selectedMedicalCourseIds: [],
                prefmap: [
                    '北海道',   '青森県',   '岩手県',   '宮城県',
                    '秋田県',   '山形県',   '福島県',   '茨城県',   '栃木県',
                    '群馬県',   '埼玉県',   '千葉県',   '東京都',   '神奈川県',
                    '新潟県',   '富山県',   '石川県',   '福井県',   '山梨県',
                    '長野県',   '岐阜県',   '静岡県',   '愛知県',   '三重県',
                    '滋賀県',   '京都府',   '大阪府',   '兵庫県',   '奈良県',
                    '和歌山県', '鳥取県',   '島根県',   '岡山県',   '広島県',
                    '山口県',   '徳島県',   '香川県',   '愛媛県',   '高知県',
                    '福岡県',   '佐賀県',   '長崎県',   '熊本県',   '大分県',
                    '宮崎県',   '鹿児島県', '沖縄県',
                ],
                timezones: [],
                telObj: {},
                isShowPassword: false,
                isSendSms: false,
            }
        },

        computed: {
            rangeYear: function () {
                return this.yearTo - this.yearBase
            },
        },

        watch: {
            'doctor.doctor_metadata.is_sms_consultation_authorized': function (val) {
                if (!val) this.isSendSms = false
            },
        },

        created: function () {
            this.fetchTimezones()
            this.fetchMedicalCourses()
            bus.$on('open-modal-add-doctor', this.open)
        },

        beforeDestroy: function () {
            bus.$off('open-modal-add-doctor')
        },

        methods: {
            /**
             * 相談科一覧取得
             */
            fetchMedicalCourses: function () {
                axios.get( `${constants.admin.medical_courses.endpoint.base}?show=1` )
                    .then(({data}) => {
                        this.medicalCourses = data
                    })
            },

            onValidateTel: function (object) {
                if (object.number.input) {
                    this.telObj = object
                }
                else {
                    this.telObj = {
                        number: { e164: null, national: null },
                        valid: true,
                        regionCode: null,
                    }
                }
            },

            open: function () {
                this.initDoctor()
                this.selectedMedicalCourseIds = []
                this.isShowPassword = false
                this.isSendSms = false
                this.errors = {}

                this.modalShow = true

                this.initDoctorManagementTag()
                this.initDoctorLabel()
                this.initDoctorHistories()
                this.initDoctorLicenses()
            },

            initDoctor: function () {
                this.doctor = {
                    last_name: null,
                    first_name: null,
                    last_name_kana: null,
                    first_name_kana: null,
                    email: null,
                    password: null,
                    tel: '',
                    tel_national: null,
                    tel_region: null,
                    address: null,
                    postcode: null,
                    prefecture: '',
                    building: null,
                    introduction: null,
                    priority_num: 1,
                    is_test: false,
                    medical_courses: [],
                    doctor_management_tags: [],
                    doctor_labels: [],
                    doctor_histories: [],
                    doctor_licenses: [],
                    flg_reset_password: false,
                    image_url: null,
                    flg_delete_image: false,
                    timezone: 'Asia/Tokyo',
                    reservation_allow_before_min: 1440,
                    doctor_metadata: {
                        is_sms_consultation_authorized: false,
                    },
                }
            },

            /**
             * 医師管理用タグの初期化
             */
            initDoctorManagementTag: function () {
                if (!this.doctor || this.doctor.doctor_management_tags.length < 1) {
                    this.doctorManagementTags = []
                    return
                }

                this.doctorManagementTags = this.doctor.doctor_management_tags.map((tag) => {
                    return {
                        id: tag.id,
                        text: tag.name,
                        style: 'color: #3461b4; background-color: #f2f4f8; border: 1px solid #dce4ed;',
                    }
                })
            },

            /**
             * 医師管理用タグ追加時の同期処理
             * @param {array} tags
             */
            syncDoctorManagementTag: function (tags) {
                this.doctorManagementTags = tags.map((lbl) => {
                    return {
                        text: lbl.text,
                        style: 'color: #3461b4; background-color: #f2f4f8; border: 1px solid #dce4ed;',
                        tiClasses: ['ti-valid'], // VueTagsInputが自動生成している
                    }
                })
            },

            /**
             * 医師ラベルの初期化
             */
            initDoctorLabel: function () {
                if (!this.doctor || this.doctor.doctor_labels.length < 1) {
                    this.doctorLabels = []
                    return
                }

                this.doctorLabels = this.doctor.doctor_labels.map((lbl) => {
                    return {
                        id: lbl.id,
                        text: lbl.name,
                        style: 'color: #B49834; background-color: #F7F8F2; border: 1px solid #EDECDC;',
                    }
                })
            },

            /**
             * 医師ラベル追加時の同期処理
             * @param {array} labels
             */
            syncDoctorLabel: function (labels) {
                this.doctorLabels = labels.map((lbl) => {
                    return {
                        text: lbl.text,
                        style: 'color: #B49834; background-color: #F7F8F2; border: 1px solid #EDECDC;',
                        tiClasses: ['ti-valid'], // VueTagsInputが自動生成している
                    }
                })
            },

            /**
             * 略歴の初期化
             */
            initDoctorHistories: function () {
                this.doctorHistories = []

                if (!this.doctor || this.doctor.doctor_histories.length < 1) {
                    this.pushDoctorHistory()
                    return
                }
                this.doctorHistories = this.doctor.doctor_histories.map((history) => {
                    return {
                        id: history.id,
                        content: history.content,
                        accrual_year: history.accrual_year,
                    }
                });
            },

            /**
             * 略歴入力欄の追加
             */
            pushDoctorHistory: function () {
                this.doctorHistories.push({
                    id: null,
                    content: '',
                    accrual_year: null,
                })
            },

            /**
             * 資格・所属学会等の削除
             *
             * @param {number} idx
             */
            removeDoctorHistory: function (idx) {
                this.doctorHistories = this.doctorHistories.filter((_, index) => index !== idx)
            },

            /**
             * 資格・所属学会等の初期化
             */
            initDoctorLicenses: function () {
                this.doctorLicenses = []

                if (!this.doctor || this.doctor.doctor_licenses.length < 1) {
                    this.pushDoctorLicense()
                    return
                }
                this.doctorLicenses = this.doctor.doctor_licenses.map((license) => {
                    return {
                        id: license.id,
                        content: license.content,
                    }
                });
            },

            /**
             * 資格・所属学会等入力欄の追加
             */
            pushDoctorLicense: function () {
                this.doctorLicenses.push({
                    id: null,
                    content: '',
                    accrual_year: null,
                })
            },

            /**
             * 資格・所属学会等の削除
             *
             * @param {number} idx
             */
            removeDoctorLicense: function (idx) {
                this.doctorLicenses = this.doctorLicenses.filter((_, index) => index !== idx)
            },

            /**
             * 画像選択時処理
             *
             * @return {void}
             */
            bindSelectedImage: function (e) {
                const elem = e.target
                this.errors = {}

                if (elem.files.length > 0) {
                    if (elem.files[0].size > 10240000) {
                        this.errors = { profile_image: ['画像のファイルサイズは10MB以内にしてください。'] }
                        return
                    }

                    this.image.object = elem.files[0]
                    this.image.name = this.image.object.name

                    const fr = new FileReader()
                    fr.onload = () => { this.image.base64 = fr.result }
                    fr.readAsDataURL(this.image.object)
                }
            },

            /**
             * 状態初期化
             */
            initImage: function () {
                this.image = {
                    name: null,
                    object: null,
                    base64: null,
                }

                // 入力エリアリセット
                this.$refs.fileinput.reset()
            },

            /**
             * 画像削除の準備
             */
            prepareDeleteImage: function () {
                this.doctor.image_url = null
                this.initImage()
            },

            handleOk(e) {
                e.preventDefault()
                this.addDoctor()
            },

            addDoctor: async function () {
                if (this.inProgress) return
                this.inProgress = true

                const data = this.buildFormData()
                const options = { headers: { 'Content-Type': 'multipart/form-data' } }

                await axios.post(`${constants.admin.doctors.endpoint.base}`, data, options)
                    .then(({data}) => {
                        this.close()
                        this.initImage()
                        bus.$emit('fetch-doctors')

                        if (data.summary === 'The confirm sms sent.') {
                            bus.$emit('alert-success', '医師の電話番号宛に確認のショートメッセージを送信しました。')
                        }
                        else {
                            bus.$emit('alert-success', '医師を追加しました。')
                        }
                    })
                    .catch(({response}) => {
                        if (response && response.hasOwnProperty('data') && response.data.hasOwnProperty('errors')) {
                            this.errors = response.data.errors
                            bus.$emit('alert-danger')
                        }
                        else {
                            bus.$emit('alert-danger', 'システムエラーが発生しました。')
                        }
                    })

                this.inProgress = false
            },

            /**
             * FormData作成
             *
             * @return {FormData}
             */
            buildFormData: function () {
                const formData = new FormData()

                let timezone = this.doctor.timezone || ''
                if (this.$store.state.configs.timezone != 1) {
                    timezone = 'Asia/Tokyo'
                }

                formData.append('last_name', this.doctor.last_name || '')
                formData.append('first_name', this.doctor.first_name || '')
                formData.append('last_name_kana', this.doctor.last_name_kana || '')
                formData.append('first_name_kana', this.doctor.first_name_kana || '')
                formData.append('address', this.doctor.address || '')
                formData.append('postcode', this.doctor.postcode || '')
                formData.append('prefecture', this.doctor.prefecture || '')
                formData.append('building', this.doctor.building || '')
                formData.append('tel', this.telObj.number.e164 || '')
                formData.append('tel_national', this.telObj.number.national || '')
                formData.append('tel_region', this.telObj.regionCode || '')
                formData.append('email', this.doctor.email || '')
                formData.append('introduction', this.doctor.introduction || '')
                formData.append('priority_num', this.doctor.priority_num || 1)
                formData.append('is_test', this.doctor.is_test ? 1 : 0)
                formData.append('timezone', timezone)
                formData.append('reservation_allow_before_min', this.doctor.reservation_allow_before_min || 1440)
                formData.append('flg_reset_password', this.doctor.flg_reset_password ? 1 : 0)
                formData.append('password', this.doctor.password || '')
                formData.append('is_sms_consultation_authorized', this.doctor.doctor_metadata.is_sms_consultation_authorized == 1 ? 1 : 0)
                formData.append('is_send_sms', this.isSendSms ? 1 : 0)
                formData.append('send_mail', this.send_mail ? 1 : 0)

                if (this.image.object !== null && this.image.object !== void (0)) {
                    formData.append('profile_image', this.image.object)
                }

                this.selectedMedicalCourseIds.forEach((id) => {
                    formData.append('medical_courses[]', id)
                })

                this.doctorManagementTags.forEach((tag) => {
                    formData.append('doctor_management_tags[]', tag.text)
                })

                this.doctorLabels.forEach((label) => {
                    formData.append('doctor_labels[]', label.text)
                })

                this.doctorHistories.forEach((history) => {
                    formData.append('doctor_histories[]', JSON.stringify(history))
                })

                this.doctorLicenses.forEach((license) => {
                    formData.append('doctor_licenses[]', JSON.stringify(license))
                })

                return formData
            },

            close: function () {
                this.modalShow = false
            },

            /**
             * 郵便番号入力時
             */
            changePostcode: function() {
                let postcode = this.doctor.postcode
                postcode = postcode.replace('-', '')

                axios.get( `${constants.admin.zip.endpoint.base}?postcode=${postcode}` )
                    .then(({data}) => {
                        try {
                            let newPrefecture = data.data[0].ja.prefecture
                            let newAddress = data.data[0].ja.address1 + data.data[0].ja.address2 + data.data[0].ja.address3 + data.data[0].ja.address4
                            this.doctor.prefecture = newPrefecture
                            this.doctor.address = newAddress
                        }
                        catch (e) {
                            this.doctor.prefecture = ''
                            this.doctor.address = ''
                        }
                    })
            },

            /**
             * タイムゾーン一覧取得
             */
            fetchTimezones: function () {
                axios.get(constants.admin.common.endpoint.timezone)
                    .then(({data}) => {
                        const momentTimezones = moment.tz.names()
                        this.timezones = data.data.filter((d) => momentTimezones.includes(d.key))
                    })
            },
        },
    }
</script>

<style scoped lang="scss">
.sectionHeader {
    margin-bottom: 12px;
    font-size: 18px;
    font-weight: bold;
    color: #7D868D;
}

.textPrefix,
.textSuffix {
    font-size: 13px;
}

.selectReservationAllowBeforeMin {
    width: 160px;
}

.c-upload__image--default {
    max-width: 200px;
}

.vc-input-password-append {
    cursor: pointer;
}

.medicalCourseCheckboxes {
    height: 200px;
    padding: 12px 0;
    overflow-y: scroll;
    border: 1px solid #ced4da;
    border-radius: 0.25rem;

    &.is-invalid {
        border: 1px solid #dc3545;
    }
}

fieldset {
    min-width: 100%;
}

#birth_year {
    min-width:60px;
}
</style>

<style lang="scss">
.is-invalid {
    .custom-file-label {
        border: 1px solid #dc3545;
    }
}

div.input-profile-image-wrapper {
    span.form-file-text {
        color: #495057;
        font-size: 0.75rem;
        line-height: 24px;
    }
}
</style>
